import React from "react"
import Loader from "../../ui/loader"
import { Button } from "../../ui/button"

interface Props {
  setShowDeleteDialogueModal: any
  availability: any
  deleteAvailabilityRule: any
  loading: any
}

const DeleteAvailabilityModal: React.FC<Props> = ({
  setShowDeleteDialogueModal,
  availability,
  deleteAvailabilityRule,
  loading,
}) => {
  return (
    <div
      className="fixed w-screen h-screen top-0 left-0 zoee-backdrop-filter 
            z-[9001] flex items-center justify-center"
    >
      <div
        className="px-[40px] md:px-[100px] py-[80px] max-h-[90vh] w-[90%] md:w-[800px] max-w-[95%] bg-white 
                        main-shadow rounded-[16px] flex flex-col items-center relative overflow-y-auto"
      >
        <h1 className="text-black text-[18px] md:text-[28px] font-semibold text-center mb-[36px]">
          Caution! You are about to permanently delete this schedule.
        </h1>
        <div className="w-full flex flex-col gap-[40px] text-[18px] items-center text-center">
          Are you sure you want to delete the {availability.name} schedule?
        </div>
        <div className="flex gap-4 mt-8 justify-center">
          <Button
            onClick={() => setShowDeleteDialogueModal(false)}
            variant="secondary"
          >
            {loading ? <Loader /> : "Cancel"}
          </Button>
          <Button onClick={deleteAvailabilityRule} variant="destructive">
            {loading ? <Loader /> : "Confirm"}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default DeleteAvailabilityModal
